var map = {
	"./albergolosone.jpg": 111,
	"./alpina.jpg": 112,
	"./ameronswissmountain.jpg": 113,
	"./artdecomontana.jpg": 114,
	"./arthotel_riposo.jpg": 115,
	"./atlantis.jpg": 116,
	"./backstage-vernissage.jpg": 117,
	"./badrutt-s-palace.jpg": 118,
	"./baur-au-lac.jpg": 119,
	"./beatus.jpg": 120,
	"./beaurivage.jpg": 121,
	"./beaurivagepalace.jpg": 122,
	"./bodmi.jpg": 123,
	"./buergenstock.jpg": 124,
	"./castello_del_sole.jpg": 125,
	"./chedi.jpg": 126,
	"./chesa-randolina.jpg": 127,
	"./de_rougemont.jpg": 128,
	"./doldenhorn.jpg": 129,
	"./dolder-grand.jpg": 130,
	"./eden-roc.jpg": 131,
	"./ermitage.jpg": 132,
	"./fairmontlemontreux.jpg": 133,
	"./fourseasons.jpg": 134,
	"./fruttfamilylodge.jpg": 135,
	"./giardino.jpg": 136,
	"./ginabelle.jpg": 137,
	"./grandhotelquellenhof.jpg": 138,
	"./gstaad_palace.jpg": 139,
	"./hof_weissbad.jpg": 140,
	"./huus-gstaad.jpg": 141,
	"./kempinski.jpg": 142,
	"./kulm.jpg": 143,
	"./la-reserve-geneve.jpg": 144,
	"./le-grand-bellevue.jpg": 145,
	"./lenkerhof.jpg": 146,
	"./lestroisrois.jpg": 147,
	"./maerchenhotelbraunwald.jpg": 148,
	"./mandarinoriental.jpg": 149,
	"./mirador.jpg": 150,
	"./nira-alpina.jpg": 151,
	"./pirmin_zurbriggen.jpg": 152,
	"./placeholder.jpg": 153,
	"./priva.jpg": 154,
	"./radissonblue.jpg": 155,
	"./rockresort.jpg": 156,
	"./romantik-hotel-julen-zermatt.jpg": 157,
	"./saratzt.jpg": 158,
	"./schweizerhof.jpg": 159,
	"./schweizerhofbern.jpg": 160,
	"./spitzhorn.jpg": 161,
	"./sunstar-arosa.jpg": 162,
	"./suvretta-house.jpg": 163,
	"./swiss_holiday_park.jpg": 164,
	"./thehide.jpg": 165,
	"./tschuggen.jpg": 166,
	"./ultima-gstaad.jpg": 167,
	"./valbellainn.jpg": 168,
	"./valsana.jpg": 169,
	"./victoriajungfrau.jpg": 170,
	"./vitznauerhof.jpg": 171,
	"./wellnesshotelgolfpanorama.jpg": 172,
	"./widder.jpg": 173
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 64).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 71;
module.exports = webpackAsyncContext;